import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsPageComponent } from './details-page/details-page.component';
// import { TAPDetailsPageComponent } from './details-page/details-page.tap.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { StepsModule } from '../steps/steps.module';
import { BookingOptionsModule } from '../options/options.module';
import { ShoppingCartModule } from '../shopping-cart/shopping-cart.module';
import { ExtrasFlightModule } from '../extras/extras-flight/extras-flight.module';
import { TimeTothinkRoutesRoutingModule } from './time-to-think-routing.module';
import { PaymentComponent } from './payment/payment.component';
import { TAPPaymentComponent } from './payment/payment.tap.component';
import { PaymentModule } from '@ibe.components/shared/payment/payment.module';
import { PaymentModule as BookingPaymentModule } from '@ibe.components/booking/payment/payment.module';

/* REPLICATED FILES */
import { INDRADetailsPageComponent } from './details-page/details-page.indra.component';

@NgModule({
	declarations: [
		DetailsPageComponent,
		// TAPDetailsPageComponent,
		INDRADetailsPageComponent,
		PaymentComponent,
		TAPPaymentComponent
	],
	imports: [
		CommonModule,
		TAPCommonModule,
		SharedModule,
		StepsModule,
		BookingOptionsModule,
		ShoppingCartModule,
		ExtrasFlightModule,
		TimeTothinkRoutesRoutingModule,
		PaymentModule,
		BookingPaymentModule
	],
	// exports: [TAPDetailsPageComponent],
	exports: [INDRADetailsPageComponent],
})
export class TimeToThinkModule { }
